var moment = require('moment-timezone')

import Vue from 'vue'
import store from '~/store'

Vue.filter('formatDate', function (value) {
  if (value) {
    var user = store.getters['auth/user']
    if (!user) {
      let dateFormat = 'DD.MM.YYYY'
      if ('format_date' in window.config) {
        dateFormat = window.config.format_date
      }
      return moment.utc(value).format(dateFormat)
    }
    return moment.utc(value).format(user.format_date)
  }
})

Vue.filter('formatDatetime', function (value) {
  if (value) {
    var user = store.getters['auth/user']
    if (!user) {
      let dateTimeFormat = 'DD.MM.YYYY HH:mm'
      if ('format_datetime' in window.config) {
        dateTimeFormat = window.config.format_datetime
      }
      return moment.utc(value).format(dateTimeFormat)
    }
    return moment.utc(value).tz(user.timezone).format(user.format_datetime)
  }
})

Vue.filter('formatTime', function (value) {
  if (value) {
    var user = store.getters['auth/user']
    if (!user) {
      let timeFormat = 'DD.MM.YYYY HH:mm'
      if ('format_time' in window.config) {
        timeFormat = window.config.format_time
      }
      return moment.utc(value).format(timeFormat)
    }
    return moment.utc(value).tz(user.timezone).format(user.format_time)
  }
})

Vue.filter('formatMonth', function (value) {
  if (value && value !== '0000-00-00 00:00:00') {
    return moment.utc(value).format("MMMM YYYY")
  }
  return ''
})

Vue.filter('formatYear', function (value) {
  if (value && value !== '0000-00-00 00:00:00') {
    return moment.utc(value).format("YYYY")
  }
  return ''
})

Vue.filter('formatPercentage', function (value) {
  if (value) {
    return parseFloat(value * 100).toFixed(2)
  }
})

Vue.filter('formatMonthOnly', function (value) {
  if (value && value !== '0000-00-00 00:00:00') {
    return moment.utc(value).format('MMM')
  }
  return ''
})
